import React, { useEffect } from 'react';
import apiCalls from './api/apiCalls';
import '../src/assets/css/styles.css';
import '../src/input.css'
import { RouterProvider } from "react-router-dom";
import AppRouter from 'src/layout/routeConfig';
import { OidcProvider } from 'redux-oidc';
import store from "src/store/index";
import { userManager } from './authentication';
import { Provider, connect } from "react-redux";
import { getAdminDetails, getIpRegisteryData } from './reducers/authReducer';
import { getModules } from './reducers/commonReducer';
import { useAuth0 } from "@auth0/auth0-react";

function App() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    localStorage.setItem("__url", window.location.pathname);
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect({ redirect_uri: process.env.REACT_APP_REDIRECT_URI });
    }
  }, [isAuthenticated, isLoading]);

  return (
    <Provider store={store}>
      <OidcProvider userManager={userManager} store={store}>
        <React.StrictMode>
          {isLoading ? <div className='loader-content'><div className="loader"></div></div>
            : <RouterProvider router={AppRouter()} />}
        </React.StrictMode>
      </OidcProvider>
    </Provider>
  );
}

const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
}

const connectDispatchToProps = dispatch => {
  return {
    getmemeberInformation: () => {
      dispatch(getAdminDetails());
    },
    getAdminModules:()=>{
      dispatch(getModules());
    },
    trackauditlogs: () => {
      dispatch(getIpRegisteryData());
    }
  }
}

export default connect(connectStateToProps, connectDispatchToProps)(App);